export const AppRoles = {
    Administrator: "Administrator",
    Brand: "Brand",
    Retailer: "Retailer",
    User: "User"
} as const;

export type AppRoles = typeof AppRoles[keyof typeof AppRoles];